import DropDown from '../../../plugins/dropdown.js';

export default DropDown;